import React, { Component } from "react";
import { Row } from "antd";

export class SectionContent extends Component<any> {
	render() {
		return <Row className="course__builder__sectionContent ml-8 mr-8">{this.props.children}</Row>;
	}
}
